export default __webpack_public_path__ + "static/media/arrow-dropdown.3725e9ef.svg";